module.exports = __webpack_public_path__ + "img/icon-apple.fd15f3b2.svg";